import { render } from "./SlideThumbnails.vue?vue&type=template&id=684fb159&scoped=true&ts=true"
import script from "./SlideThumbnails.vue?vue&type=script&lang=ts"
export * from "./SlideThumbnails.vue?vue&type=script&lang=ts"

import "./SlideThumbnails.vue?vue&type=style&index=0&id=684fb159&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684fb159"]])

export default __exports__